// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";

// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";

// export default function SubmittedapplicationsD() {

//   const [applications, setApplications] = useState([]);
 
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch(`${API_BASE_URL}/getApplications`)
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data); // Log the API response
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);



//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">All Applications</h1>
//       <Table className
//         striped
//         bordered
//         hover
//         style={{
//           marginTop: "20px",
//           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <thead>
//           <tr>
//             <th>Applicant Name</th>
//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Application</th>
//           </tr>
//         </thead>
//         <tbody>
//           {/* Display applications */}
//           {Array.isArray(applications) &&
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>{app.Name}</td>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>{app.Status}</td>
//                 <td>
//                   <button
//                     className="View_Button"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(
//                         /\s+/g,
//                         "_"
//                       );
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank");
//                     }}
//                   >
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </Table>

    
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function SubmittedapplicationsD() {
  const [applications, setApplications] = useState([]);
  const [awards, setAwards] = useState([]);
  const [selectedAward, setSelectedAward] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

  // Fetch applications from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/getApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Applications:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array for applications:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));

    // Fetch awards from the backend
    fetch(`${API_BASE_URL}/getAwards`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Awards:", data);
        if (Array.isArray(data)) {
          setAwards(data);
        } else {
          console.error("API did not return an array for awards:", data);
        }
      })
      .catch((error) => console.error("Error fetching awards:", error));
  }, []);

  // Generate years up to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected award and year
  const filteredApplications = applications.filter((app) => {
    const matchesAward = selectedAward ? app.Award_Type === selectedAward : true;
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesAward && matchesYear;
  });

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">All Applications</h1>
      <div style={{ margin: "20px 0", display: "flex", gap: "20px" }}>
        <div>
          <label htmlFor="awardFilter">Filter by Award: </label>
          <select
            id="awardFilter"
            value={selectedAward}
            onChange={(e) => setSelectedAward(e.target.value)}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">All Awards</option>
            {awards.map((award) => (
              <option key={award.Award_Id} value={award.Name}>
                {award.Name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Application</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}